export default __webpack_public_path__ + "static/media/audio_poster.55ff4f8d.png";